const C = {
  name: "Door",
  dimensions: { width: 40, height: 40 },
  content: `
    <g fill="currentColor" stroke="none">
        <path d="M13.4068 4H9.60684C8.70684 4 8.00684 4.7 8.00684 5.6V19.5C8.00684 20.3 8.70684 21 9.60684 21H13.5068C14.4068 21 15.1068 20.3 15.1068 19.4V5.6C15.0068 4.7 14.3068 4 13.4068 4ZM13.0068 19H11.0068C10.4068 19 10.0068 18.6 10.0068 18V6H12.0068C12.6068 6 13.0068 6.4 13.0068 7V19Z"/>
        <path d="M22.4068 4H18.5068C17.7068 4 17.0068 4.7 17.0068 5.6V19.5C17.0068 20.4 17.7068 21.1 18.6068 21.1H22.5068C23.4068 21.1 24.1068 20.4 24.1068 19.5V5.6C24.0068 4.7 23.3068 4 22.4068 4ZM22.0068 19H20.0068C19.4068 19 19.0068 18.6 19.0068 18V6H21.0068C21.6068 6 22.0068 6.4 22.0068 7V19Z"/>
        <path d="M31.0068 38H28.0068V2C28.0068 0.9 27.1068 0 26.0068 0H6.00684C4.90684 0 4.00684 0.9 4.00684 2V38H1.00684C0.406836 38 0.00683594 38.4 0.00683594 39C0.00683594 39.6 0.406836 40 1.00684 40H6.00684H26.0068H31.0068C31.6068 40 32.0068 39.6 32.0068 39C32.0068 38.4 31.6068 38 31.0068 38ZM6.00684 2H25.0068C25.6068 2 26.0068 2.4 26.0068 3V38H7.00684C6.40684 38 6.00684 37.6 6.00684 37V2Z"/>
        <path d="M9.00684 25C9.55912 25 10.0068 24.5523 10.0068 24C10.0068 23.4477 9.55912 23 9.00684 23C8.45455 23 8.00684 23.4477 8.00684 24C8.00684 24.5523 8.45455 25 9.00684 25Z"/>
    </g>
  `
};
export {
  C as Door
};
